import { TableHeadCell } from "@shared/primitive-components"

export const unsafeMilesHeaderProps = {
  header: `Unsafe Miles`,
  tooltipContent: `The total number of miles spent driving over the speed limit of each area`,
}

export const UnsafeMilesHeader = () => <TableHeadCell {...unsafeMilesHeaderProps} />
